import { useEffect, useState } from "react";
import { useParams, useNavigate, replace } from "react-router-dom";
import api from "../../services/api";
import './destalhes-filme.css'

function Filme(){

    const [filme, setFilme] = useState({});
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const {id} = useParams();
    useEffect(()=>{
        async function  loadFilme() {
            await api.get(`/movie/${id}` , {
                params: {
                    api_key: "2702faf1ee37ee08fe6c848f89772099",
                    language: "pt-BR",
                    page: 1
                }
            })
            .then((response)=>{
                console.log(response.data)
              setFilme(response.data)
              setLoading(false)
            })
            .catch((error)=>{
                console.log('filme não encontrado', error)
                navigate('/', {replace: true});
                return;
            })
        }

        loadFilme()

        return ()=>{
            console.log('COMPONENTE FOI DESMONTAdo')
        }
    }, [navigate, api])

    function salvarFilme(){
        const minhaLista = localStorage.getItem('@primeFlix')

        let filmesSalvos = JSON.parse(minhaLista) || [];
        let hasFilme = filmesSalvos.some((filmeSalvo)=> filmeSalvo.id === filme.id)

        if(hasFilme){
            alert('esse filme já está na lista de salvos')
            return;
        }
        filmesSalvos.push(filme)
        localStorage.setItem('@primeFlix' , JSON.stringify(filmesSalvos))
        alert('filme adicionado nos favoritos')
    }

    if(loading){
        return(
            <div>
                <h2>Carregando detalhes do filme...</h2>
            </div>
        )
    }
    return(
        <div className="divDetalhes">
           <img src={`https://image.tmdb.org/t/p/original/${filme.backdrop_path}`}alt={filme.title}></img>
           <h2>{filme.title}</h2>
           <h3>Sinopse</h3>
           <p>{filme.overview}</p>
           <strong>Avaliação: {filme.vote_average}</strong>

           <div className="botoes">
              <button onClick={salvarFilme}>Salvar</button>
              <button>
                <a href={`https://www.youtube.com/results?search_query=${filme.title}`} target="blank">Trailer</a>
              </button>
           </div>

        </div>
    )
}

export default Filme;